import {UriBuilder} from './UriBuilder';
import {User} from '../Models';
import {CustomerDataDTO} from '../DTOs';
import {BaseModelService} from './BaseModelService';

export class AuthService extends BaseModelService<User> {
  constructor(apiUrl) {
    super(User);
    this.apiBaseUrl = apiUrl;
  }

  async fetchUserData(session: string): Promise<User> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('v1/login/users')
      .build();
    const result = await this.restClient.GET(url, {'Authorization': `Bearer ${session}`});
    if (result.response) {
      return new User(result.response);
    }
    return this.throwAPIError(result.error);
  }

  async createTemporaryGuestProfile(customerData: CustomerDataDTO): Promise<string | null> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('v1/login/auth/registration/guest')
      .build();
    const result = await this.restClient.POST(url, customerData, {'Content-Type': 'application/json'});
    if (result.response && result.response.success) {
      return result.response.token;
    } else {
      return null;
    }
  }

  async createGuestProfile(customerData: CustomerDataDTO): Promise<User> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('v1/login/users')
      .build();
    const result = await this.restClient.POST(url, customerData, {'Content-Type': 'application/json'});

    if (result.response) {
      return new User(result.response);
    }
    return this.throwAPIError(result.error);
  }

  getLoginUrl(redirectTo: string, language: string): string {
    // add the session to the redirect url and read it from there when we get back to the login page.
    return `${this.apiBaseUrl}/${language}?returnUrl=${redirectTo}`;
  }

  /**
   * Validates AND renews the session expiry if exists
   *
   * @param session
   */
  async validateSession(session: string): Promise<boolean> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('v1/auth/session/validate')
      .build();
    const result = await this.restClient.POST(url, '', {'Authorization': `Bearer ${session}`});
    if (result.response && 'valid' in result.response) {
      return result.response.valid;
    }

    return false;
  }

  async logout(session: string): Promise<boolean> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('v1/auth/session/logout')
      .build();
    const result = await this.restClient.POST(url, '', {'Authorization': `Bearer ${session}`});
    if (result.response && 'success' in result.response) {
      return result.response.success;
    }

    return false;
  }
}
